export default __webpack_public_path__ + "static/media/Avatar-7.6e8620d6.svg";